import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Paths } from './core/constants/path.constants';
import { VotaLayoutComponent } from './layouts/vota-layout/vota-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { authGuard } from './core/guard/auth.guard';
import { InfluencerDetailsComponent } from './features/raffles/components/influencer-details/influencer-details.component';
import { InfluencerMediaComponent } from './features/raffles/components/influencer-media/influencer-media.component';

const routes: Routes = [
  {
    path: Paths.AUTH,
    component: AuthLayoutComponent,
    children: [
      {
        path: Paths.EMPTY,
        loadChildren: () =>
          import('./features/auth/auth.module').then((m) => m.AuthModule),
      },
    ],
    canActivate: [authGuard],
  },
  {
    path: Paths.EMPTY,
    component: VotaLayoutComponent,
    children: [
      {
        path: Paths.INFLUENCER,
        loadChildren: () =>
          import('./features/influencer/influencer.module').then(
            (m) => m.InfluencerModule
          ),
      },
      {
        path: Paths.EVENT,
        loadChildren: () =>
          import('./features/events/events.module').then((m) => m.EventsModule),
      },
      {
        path: Paths.PROFILE,
        loadChildren: () =>
          import('./features/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
      },
      {
        path: Paths.POLL,
        loadChildren: () =>
          import('./features/poll/poll.module').then((m) => m.PollModule),
      },
      {
        path: Paths.EMPTY,
        loadChildren: () =>
          import('./features/raffles/raffle.module').then(
            (m) => m.RaffleModule
          ),
      },
      {
        path: `:username/${Paths.MEDIA}`,
        component: InfluencerMediaComponent,
      },
      {
        path: ':username',
        component: InfluencerDetailsComponent,
      },
    ],
  },
  {
    path: Paths.NOT_FOUND,
    redirectTo: Paths.EMPTY,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
